import { useGraphQLQuery } from '@betterment/graphql';
import { Card, H2, Separator } from '@betterment/samba-react';

import { SambaAutoLink } from '~/b4b/components/SambaAutoLink';
import { useCurrentEmployerId } from '~/b4b/utils/currentEmployer';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { TaskListDocument } from '../graphql/query.taskList.generated';
import { TaskList } from '../task-list/TaskList';

const LIMIT = 4;

export const TasksCard = () => {
  const employerId = useCurrentEmployerId();
  const { data, dataState } = useGraphQLQuery(TaskListDocument, {
    variables: { employerId },
  });

  if (dataState !== 'complete') {
    return (
      <Card css={{ p: 'space.300' }}>
        <Card.Header>
          <H2 variant="title200">Tasks</H2>
        </Card.Header>
      </Card>
    );
  }

  const { count, items } = data.employer.tasks;

  if (items.length === 0) {
    return (
      <Card css={{ p: 'space.300' }}>
        <Card.Header>
          <H2 variant="title200">Tasks</H2>
          <Separator css={{ my: 'space.300' }} />
          You're all caught up!
        </Card.Header>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header css={{ p: 'space.300', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <H2 variant="title200">Tasks</H2>
        {count > LIMIT && <SambaAutoLink to={urlBuilder.tasks.path}>View all {count} tasks</SambaAutoLink>}
      </Card.Header>
      <Card.Content css={{ pb: 'space.100' }}>
        <Separator css={{ fullWidthWithInset: 'space.300' }} />
        <TaskList tasks={items.slice(0, LIMIT)} />
      </Card.Content>
    </Card>
  );
};
